import styled from 'styled-components';
import { Flex } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'BusinessProfile' })
    .attrs((props) => ({
        ...props,
        width: 'calc(100% - 16px)',
        minWidth: '605px',
        background: 'var(--background-primary)',
        borderRadius: 3,
        p: 2,
        spacing: 2,
        overflow: 'hidden',
    }))``;
